import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import convert from 'htmr';
import { isEmpty, map, noop, replace } from 'lodash/fp';
import useMedia from '../_utils/useMedia';
import IconCaret from '../../files/caret.svg';

const DESKTOP_MEDIA_QUERY = '(min-width: 1330px)';

function SidebarNavAccordion({ level, url, current, label, children }) {
  const initialIsExpanded = useMedia(
    // Media queries
    [DESKTOP_MEDIA_QUERY],
    // values
    [current],
    // Default value
    level > 1 ? current : false
  );

  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

  useEffect(() => {
    if (typeof window !== 'object' || level !== 1) {
      return noop;
    }

    function handleResize() {
      const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
      setIsExpanded(mediaQuery.matches);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  const itemClasses = classnames(
    `sidebar-nav__item sidebar-nav__item--l${level}`,
    { current },
    { active: isExpanded }
  );
  const linkClasses = classnames(
    `sidebar-nav__link sidebar-nav__link--l${level}`,
    { current }
  );
  const buttonClasses = classnames(
    `sidebar-nav__btn sidebar-nav__btn--l${level}`,
    { current },
    { active: isExpanded }
  );
  const listClasses = classnames(
    `sidebar-nav__list sidebar-nav__list--l${level + 1} margins-off`,
    { current },
    { active: isExpanded }
  );
  const listId = `sidebar-nav-${replace(/\W+/g, '-', url)}`;
  return (
    <li key={url}>
      <div className={itemClasses}>
        <a href={url} className={linkClasses}>
          {convert(label)}
        </a>
        {!isEmpty(children) && (
          <button
            className={buttonClasses}
            onClick={() => setIsExpanded(!isExpanded)}
            aria-expanded={isExpanded}
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
            aria-controls={listId}
          >
            <IconCaret focusable={false} />
          </button>
        )}
      </div>
      {!isEmpty(children) && (
        <ul id={listId} className={listClasses}>
          {map(SidebarNavAccordion, children)}
        </ul>
      )}
    </li>
  );
}

const SidebarNav = ({ sidebarNav }) => {
  if (isEmpty(sidebarNav)) {
    return null;
  }

  return (
    <nav className="sidebar-nav">
      <ul className="sidebar-nav__list sidebar-nav__list--l1 active current margins-off">
        {map(SidebarNavAccordion, [sidebarNav])}
      </ul>
    </nav>
  );
};

export default SidebarNav;
